import { render, staticRenderFns } from "./Face.vue?vue&type=template&id=9bfd7242"
import script from "./Face.vue?vue&type=script&lang=js"
export * from "./Face.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports